__turbopack_context__.v({
  "background": "Background-module__NUJVBG__background",
});
